import { PolicyAttachmentType } from '~domain/model/policy/attachment/policy-attachment-type';

export const policies = {
  attachments: {
    types: {
      newBusinessPaymentSchedule: 'New Business Payment Schedule',
      policyChangePaymentSchedule: 'Policy Change Payment Schedule',
      renewalPaymentSchedule: 'Renewal Payment Schedule',
      reissuePaymentSchedule: 'Reissue Payment Schedule',
      rewritePaymentSchedule: 'Rewrite Payment Schedule',
      reinstatementPaymentSchedule: 'Reinstatement Payment Schedule',
      paymentScheduleNoPolicyTransaction: 'Payment Schedule No Policy Transaction',
      billingWithdrawalRejectionNotice: 'Billing Withdrawal Rejection Notice',
      billingOverduePaymentNotice: 'Billing Overdue Payment Notice',
      billingFinalBillNotice: 'Billing Final Bill Notice',
      billingRefundIssued: 'Billing Refund Issued',
      paymentReceivedPolicyReinstated: 'Payment Received and Policy Reinstated',
      paymentRequiredOutstandingBalance: 'Payment Required Outstanding Balance',
      billingCollectionNotice: 'Billing Collection Notice',
      billingCreditCardExpired: 'Billing Credit Card Expired',
      insurerNonRenewal: 'Insurer Non-Renewal',
      insurerCancellationReinstatable: 'Insurer Cancellation with Option to Reinstate',
      insurerCancellationDefinitive: 'Insurer Cancellation with No Option to Reinstate',
      insuredCancellationRequest: 'Cancellation Request by Insured',
      insurerCancellation: 'Cancelled by Insurer',
      newBusinessPolicyDeclaration: 'New Business Policy Declaration',
      newBusinessLiabilityCertificates: 'New Business Liability Certificates',
      policyChangePolicyDeclaration: 'Policy Change Policy Declaration',
      policyChangeLiabilityCertificates: 'Policy Change Liability Certificates',
      renewalPolicyDeclaration: 'Renewal Policy Declaration',
      renewalLiabilityCertificates: 'Renewal Liability Certificates',
      reissuePolicyDeclaration: 'Reissue Policy Declaration',
      reissueLiabilityCertificates: 'Reissue Liability Certificates',
      rewritePolicyDeclaration: 'Rewrite Policy Declaration',
      rewriteLiabilityCertificates: 'Rewrite Liability Certificates',
      reinstatementPolicyDeclaration: 'Reinstatement Policy Declaration',
      reinstatementLiabilityCertificates: 'Reinstatement Liability Certificates',
      underwritingRequest: 'Underwriting Request',
      claimOpeningNotice: 'Claim Opening Notice',
      claimClosingNotice: 'Claim Closing Notice',
      claimAdjusterAssignment: 'Claim Adjuster Assignment',
      claimAutoRentalNotice: 'Claim Auto Rental Notice',
      claimTotalLossNotice: 'Claim Total Loss Notice',
      claimAutoFaultDeterminationNotice: 'Claim Auto Fault Determination Notice',
      claimPaymentNotice: 'Claim Payment Notice',
      policyContract: 'Insurance Policy Contract',
      billingStatement: 'Billing Statement',
      billingNotice: 'Billing Notice',
      cancellationNotice: 'Cancellation Notice',
      okEDelivery: 'Ok - eDelivery',
      unknown: 'Unknown',
    } satisfies Record<PolicyAttachmentType, string>,
  },
};

export type PoliciesTranslations = typeof policies;
